import React from 'react';
import { Lock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const PasswordTab = ({ passwordData, saving, onChange, onSubmit }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Lock className="w-5 h-5 text-yellow-400" />
        Change Password
      </CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="currentPassword" className="text-purple-100">Current Password</Label>
          <Input
            id="currentPassword"
            name="currentPassword"
            type="password"
            value={passwordData.currentPassword}
            onChange={onChange}
            required
            className="bg-purple-900/50 border-purple-600 text-white"
            data-testid="current-password-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="newPassword" className="text-purple-100">New Password</Label>
          <Input
            id="newPassword"
            name="newPassword"
            type="password"
            value={passwordData.newPassword}
            onChange={onChange}
            required
            className="bg-purple-900/50 border-purple-600 text-white"
            data-testid="new-password-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirmPassword" className="text-purple-100">Confirm New Password</Label>
          <Input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={passwordData.confirmPassword}
            onChange={onChange}
            required
            className="bg-purple-900/50 border-purple-600 text-white"
            data-testid="confirm-new-password-input"
          />
        </div>
        <Button
          type="submit"
          disabled={saving}
          className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
          data-testid="change-password-btn"
        >
          {saving ? 'Changing...' : 'Change Password'}
        </Button>
      </form>
    </CardContent>
  </Card>
);
